import { defineStore } from "pinia";

const API_URL = process.env.VUE_APP_MANAGER_API_URL;

export const useMainStore = defineStore("main", {
  state: () => ({
    callLogSite: "",
    title: "Home",
    apiURL: API_URL,
    loader: false,
    localizationResources: {},
    localizationLanguage: null,
    prevCompanyId: "",
    activeRoute: "",
    cognitoInfo: {},
    faceBookpopup: [],
    dashboardInfo: {},
    menudataInfo: {},
    routedataInfo: {},
    filterInfo: {},
    dashboardFilter: {},
    leads: {},
    headerSidebar: {},
    emailforforgotpassword: "",
    integrationsValue: "",
    moduleValue: "",
    errorLogSite: "",
    errorIntegrationsValue: "",
    errorModuleValue: "",
    email: "",
    isFacebook: false,
    isTiktok: false,
    session: "",
    accProducts: "0",
    accPages: "0",
    accOrder: "0",
    orderIntegrationsValue: "",
    accMarket: "0",
    accContact: "0",
    contactIntegrationsValue: "",
    accInventory: "0",
    inventoryIntegrationsValue: "",
    accReceipt: "0",
    receiptIntegrationsValue: "",
    ratingsAndReviewsSelectedSiteId: "",
    isMultiPromotionsEnable: false,
    isEnableMediaComponent: false,
    isEnableDeprecatedSite: false,
    isRatingsAndReviewsEnabled: false,
    notifiedErrorCount: -1,
    globalSearch: {
      value: "",
      matchMode: "contains",
    },
    selectedLanguage: "en",
    routes: [
      { Name: "/", Value: "home" },
      { Name: "/essence", Value: "essence" },
      { Name: "/deals", Value: "modifydeal" },
      { Name: "/site/list", Value: "sitelist" },
      { Name: "/site/create", Value: "sitecreate" },
      { Name: "/site/edit/:id", Value: "siteedit" },
      { Name: "/sites", Value: "newsitelist" },
      { Name: "/acceleratorsite", Value: "acceleratorsite" },
      { Name: "/acceleratorsite/:id", Value: "acceleratoredit" },
      { Name: "/leadads", Value: "leadadslist" },
      { Name: "/elevatelist", Value: "elevatelist" },
      { Name: "/elevatelist/:id", Value: "elevateedit" },
      { Name: "/newsite/create", Value: "newsitecreate" },
      { Name: "/newsite/edit/:id", Value: "newsiteedit" },
      { Name: "/newsite/copy/:id", Value: "newsitecopy" },
      { Name: "/site/copy/:id", Value: "sitecopy" },
      { Name: "/performance", Value: "performance" },
      { Name: "/myambassadors", Value: "myambassadors" },
      { Name: "/myfriends", Value: "myfriends" },
      { Name: "/relations", Value: "relations" },
      { Name: "/user/list", Value: "userlist" },
      { Name: "/user/create", Value: "usercreate" },
      { Name: "/user/edit/:id", Value: "useredit" },
      { Name: "/companies", Value: "companylist" },
      { Name: "/company/create", Value: "companycreate" },
      { Name: "/company/edit/:id", Value: "companyedit" },
      { Name: "/changelog/:id", Value: "changelog" },
      { Name: "/changelog/:id", Value: "changelog" },
      { Name: "/contact/list", Value: "contactlist" },
      { Name: "/errorsummary", Value: "errorsummary" },
      { Name: "/calllog", Value: "calllogsite" },
      { Name: "/calllog/:id", Value: "calllogdashboard" },
      { Name: "/calllog/:id/:keyid", Value: "calllogview" },
      { Name: "/sessiondashboard", Value: "sessionssite" },
      { Name: "/sessiondashboard/:id", Value: "sessionsdashboard" },
      { Name: "/sessiondashboard/:id/:keyid", Value: "sessionsview" },
      { Name: "/sessionlogdashboard/:id", Value: "sessionlogdashboard" },
      { Name: "/sessionlogdashboard/:id/:keyid", Value: "sessionlogview" },
      { Name: "/errorlogbycompany", Value: "companyerrordashboard" },
      { Name: "/errorlogbycompany/:id", Value: "companyerrorview" },
      { Name: "/ongoingerror", Value: "ongoingerrordashboard" },
      { Name: "/ongoingerrorbyerrorlogid/:id", Value: "ongoingerrorview" },
      { Name: "/allongoingerror", Value: "allongoingerrordashboard" },
      { Name: "/allongoingerrorbyerrorlogid/:id", Value: "allongoingerrorview" },
      { Name: "/activeorders", Value: "activeorders" },
      { Name: "/sitechangelog/:id", Value: "siteChangelog" },
      { Name: "/companychangelog/:id", Value: "companyChangelog" },
      { Name: "/editdeal/:id", Value: "editdealnew" },
      { Name: "/newonsitemessage", Value: "newonsitemessage" },
      { Name: "/deals/deallist", Value: "managedeallistnew" },
      { Name: "/copydealnew/:id", Value: "copydeal" },
      { Name: "/copydeal/:id", Value: "copydealnew" },
      { Name: "/searchdeal/:id", Value: "dealsearch" },
      { Name: "/deals/create", Value: "managedealupdateCreate" },
      { Name: "/deals/edit/:id", Value: "managedealupdateById" },
      { Name: "/updatetranslation", Value: "updatetranslation" },
      { Name: "/notfound", Value: "notfound" },
      { Name: "/signupwizard", Value: "signupwizard" },
      { Name: "/overview", Value: "overview" },
      { Name: "/contentgenerator", Value: "contentgenerator" },
      { Name: "/aicontent", Value: "aicontent" },
      { Name: "/aivideocontent", Value: "aivideocontent" },
      { Name: "/ratingreview", Value: "ratingreviewlist" },
      { Name: "/ratingreview/:id", Value: "ratingreviewedit" },
      { Name: "/reviewsdashboard", Value: "reviewsdashboard" },
      { Name: "/summariesdashboard", Value: "summariesdashboard" },
      { Name: "/reviewsdashboard/:siteId/:reviewId/:itemId/:contactId", Value: "reviewsedit" },
      { Name: "/summariesdashboard/:siteId/:itemId", Value: "summariesedit" },
      { Name: "/commentsdashboard", Value: "commentsdashboard" },
      { Name: "/commentsdashboard/:siteId/:contactId/:reviewId", Value: "commentsedit" },
      { Name: "/votesdashboard", Value: "votesdashboard" },
      { Name: "/votesdashboard/:siteId/:reviewId/:voterId", Value: "votesedit" },
      { Name: "/reviews-overview", Value: "reviewsoverview" },
      { Name: "/leadads/:id", Value: "leadads" },
      { Name: "/acceleratordashboard/products", Value: "productsite" },
      { Name: "/acceleratordashboard/products/:id", Value: "productdashboard" },
      { Name: "/acceleratordashboard/products/:id/:keyid", Value: "productview" },
      { Name: "/acceleratordashboard/products/version/:id/:keyid", Value: "productversion" },

      { Name: "/acceleratordashboard/page", Value: "pagesite" },
      { Name: "/acceleratordashboard/page/:id", Value: "pagedashboard" },
      { Name: "/acceleratordashboard/page/:id/:keyid", Value: "pageview" },
      { Name: "/acceleratordashboard/page/version/:id/:keyid", Value: "pageversion" },


      { Name: "/acceleratordashboard/orders", Value: "ordersite" },
      { Name: "/acceleratordashboard/orders/:id", Value: "orderdashboard" },
      { Name: "/acceleratordashboard/orders/:id/:keyid", Value: "orderview" },
      { Name: "/acceleratordashboard/orders/:id/:keyid/:type", Value: "orderversion" },
      { Name: "/acceleratordashboard/contacts", Value: "contactsite" },
      { Name: "/acceleratordashboard/contacts/:id", Value: "contactdashboard" },
      { Name: "/acceleratordashboard/contacts/:id/:keyid", Value: "contactview" },
      { Name: "/acceleratordashboard/inventories", Value: "inventorysite" },
      { Name: "/acceleratordashboard/inventories/:id", Value: "inventorydashboard" },
      { Name: "/acceleratordashboard/inventories/:keyid/:siteId", Value: "inventoryview" },
      { Name: "/acceleratordashboard/markets", Value: "marketsite" },
      { Name: "/acceleratordashboard/markets/:id", Value: "marketdashboard" },
      { Name: "/acceleratordashboard/markets/:id/:keyid", Value: "marketview" },
      { Name: "/acceleratordashboard/receipt", Value: "receiptsite" },
      { Name: "/acceleratordashboard/receipt/:id", Value: "receiptdashboard" },
      { Name: "/acceleratordashboard/receipt/:id/:keyid", Value: "receiptview" },
      { Name: "/essence", Value: "essence" },
      { Name: "/onsitedashboard", Value: "onsitedashboard" },
      { Name: "/blank", Value: "blank" },
    ],
    // URL parameters
    tenant: "",
    origin: "",
    emailParam: "",
    language: "",
    expectedIssuer: "",
    expectedAudience: "",
    organization: "",
    connection: "",
    refreshtoken: "",
    accesstoken: "",
  }),

  getters: {
    GetRoutePath: (state) => (pathName) => {
      const routeObj = state.routes.filter((path) => path.Value === pathName);
      if (routeObj.length > 0) {
        return routeObj[0].Name;
      }
      return null;
    },
    getGlobalSearch: (state) => state.globalSearch,
    getLocalizationResources: (state) => state.localizationResources,
  },

  actions: {
    // Localization
    setLocalizationResources(resources, language) {
      this.localizationResources = resources;
      this.localizationLanguage = language;
    },
    resetLocalizationResources() {
      this.localizationResources = {};
      this.localizationLanguage = null;
    },

    // Call Logs
    setCallLogsSite(value) {
      this.callLogSite = value;
    },
    resetCallLogLogout() {
      this.callLogSite = "";
    },

    // Error Logs
    setErrorLogsSite(value) {
      this.errorLogSite = value;
    },
    resetErrorLogsSite() {
      this.errorLogSite = "";
    },
    setErrorIntegrationsValue(value) {
      this.errorIntegrationsValue = value;
    },
    resetErrorIntegrationsValue() {
      this.errorIntegrationsValue = "";
    },
    setErrorModuleValue(value) {
      this.errorModuleValue = value;
    },
    resetErrorModuleValue() {
      this.errorModuleValue = "";
    },

    // Facebook/Tiktok
    setFacebook(value) {
      this.isFacebook = value;
    },
    setTiktok(value) {
      this.isTiktok = value;
    },
    resetFacebook() {
      this.isFacebook = false;
    },
    resetTiktok() {
      this.isTiktok = false;
    },

    // Integrations
    setIntegrationsValue(value) {
      this.integrationsValue = value;
    },
    setModuleValue(value) {
      this.moduleValue = value;
    },
    resetIntegrationsValue() {
      this.integrationsValue = "";
    },
    resetModuleValue() {
      this.moduleValue = "";
    },

    // Accelerator
    setAcceleratorProducts(value) {
      this.accProducts = value;
    },
    resetAcceleratorProducts() {
      this.accProducts = "0";
    },
    setAcceleratorPages(value) {
      this.accPages = value;
    },
    resetAcceleratorPages() {
      this.accPages = "0";
    },
    setAcceleratorOrders(value) {
      this.accOrder = value;
    },
    resetAcceleratorOrders() {
      this.accOrder = "0";
    },
    setOrderIntegrationsValue(value) {
      this.orderIntegrationsValue = value;
    },
    resetOrderIntegrationsValue() {
      this.orderIntegrationsValue = "";
    },
    setAcceleratorMarket(value) {
      this.accMarket = value;
    },
    resetAcceleratorMarket() {
      this.accMarket = "0";
    },
    setAcceleratorContact(value) {
      this.accContact = value;
    },
    resetAcceleratorContact() {
      this.accContact = "0";
    },
    setContactIntegrationsValue(value) {
      this.contactIntegrationsValue = value;
    },
    resetContactIntegrationsValue() {
      this.contactIntegrationsValue = "";
    },
    setAcceleratorInventory(value) {
      this.accInventory = value;
    },
    resetAcceleratorInventory() {
      this.accInventory = "0";
    },
    setInventoryIntegrationsValue(value) {
      this.inventoryIntegrationsValue = value;
    },
    resetInventoryIntegrationsValue() {
      this.inventoryIntegrationsValue = "";
    },
    setAcceleratorReceipt(value) {
      this.accReceipt = value;
    },
    resetAcceleratorReceipt() {
      this.accReceipt = "0";
    },
    setReceiptIntegrationsValue(value) {
      this.receiptIntegrationsValue = value;
    },
    resetReceiptIntegrationsValue() {
      this.receiptIntegrationsValue = "";
    },
    setRatingsAndReviewsSelectedSiteId(value) {
      this.ratingsAndReviewsSelectedSiteId = value;
    },

    // Feature flags
    setMultiPromotionsEnabled(value) {
      this.isMultiPromotionsEnable = value;
    },
    setMediaLibraryEnabled(value) {
      this.isEnableMediaComponent = value;
    },
    setDeprecatedEnabled(value) {
      this.isEnableDeprecatedSite = value;
    },
    setRatingsAndReviewsEnabled(value) {
      this.isRatingsAndReviewsEnabled = value;
    },

    // Error count
    setNotifiedErrorCount(value) {
      this.notifiedErrorCount = value;
    },
    resetNotifiedErrorCount() {
      this.notifiedErrorCount = -1;
    },

    // Facebook popup
    setFacebookPopupWindowFalse(siteId) {
      const popupItem = this.faceBookpopup.find((item) => item.siteid === siteId);
      if (popupItem) {
        popupItem.faceBookPopupwindow = false;
      }
    },
    setFaceBookpopupSite(info) {
      const existing = this.faceBookpopup.find((item) => item.siteid === info.siteid);
      if (!existing) {
        this.faceBookpopup.push({
          siteid: info.siteid,
          faceBookPopupwindow: false,
        });
      }
    },
    setFaceBookpopupOpen(info) {
      const existing = this.faceBookpopup.find((item) => item.siteid === info.siteid);
      if (existing) {
        existing.faceBookPopupwindow = info.faceBookPopupwindow;
      } else {
        this.faceBookpopup.push({
          siteid: info.siteid,
          faceBookPopupwindow: info.faceBookPopupwindow ?? false,
        });
      }
    },
    resetFacebookPopup() {
      this.faceBookpopup = [];
    },

    // Header/Sidebar
    setHeaderSidebar(headerSidebar) {
      this.headerSidebar = headerSidebar;
    },
    resetHeaderSidebar() {
      this.headerSidebar = {};
    },

    // Language
    setSelectedLanguage(language) {
      this.selectedLanguage = language;
    },

    // Global search
    setGlobalSearch(search) {
      this.globalSearch = search;
    },

    // Loader
    showLoader() {
      this.loader += 1;
    },
    hideLoader() {
      if (this.loader > 0) this.loader -= 1;
      else this.loader = 0;
    },

    // Title
    replaceTitle(newtitle) {
      this.title = newtitle;
      document.title = "Voyado Onsite Manager - " + newtitle;
    },

    // Password
    setForgotPasswordEmail(info) {
      this.emailforforgotpassword = info;
    },
    resetForgotPasswordEmail() {
      this.emailforforgotpassword = "";
    },

    // Login
    setLoginEmail(info) {
      this.email = info;
    },
    resetLoginEmail() {
      this.email = "";
    },

    // Session
    setSession(info) {
      this.session = info;
    },
    resetSession() {
      this.session = "";
    },

    // Cognito
    setCognitoToken(info) {
      this.cognitoInfo.token = info;
    },
    setCognitoRefreshToken(info) {
      this.refreshtoken = info;
    },
    setCognitoAccessToken(info) {
      this.accesstoken = info;
    },
    setCognitoUsername(info) {
      this.cognitoInfo.username = info;
    },
    setCognitoEmail(info) {
      this.cognitoInfo.email = info;
    },
    setCognitoInfo(info) {
      this.cognitoInfo = info;
    },
    resetCognitoInfo() {
      this.cognitoInfo = {};
    },

    // Leads
    setLeadsData(info) {
      this.leads.isLead = info;
    },
    setEcomData(info) {
      this.leads.isEcom = info;
    },
    setisElevateEnableData(info) {
      this.leads.isElevate = info;
    },
    setisShowOnSiteMessages(info) {
      this.leads.isShowOnSiteMessage = info;
    },
    setCompanystoreId(info) {
      this.leads.companystoreid = info;
    },
    resetLead() {
      this.leads = {};
    },

    // Menu/Route data
    setMenudataInfo(info) {
      this.menudataInfo = info;
    },
    resetMenudataInfo() {
      this.menudataInfo = {};
    },
    setRoutedataInfo(info) {
      this.routedataInfo = info;
    },
    resetRoutedataInfo() {
      this.routedataInfo = {};
    },

    // Company
    replaceCompanyId(newid) {
      this.cognitoInfo.companyid = newid;
      this.prevCompanyId = newid;

      this.cognitoInfo.companylist.forEach((element) => {
        element.selected = false;
      });

      const _filtered = this.cognitoInfo.companylist.filter((a) => a.value == newid)[0];
      _filtered.selected = true;
      this.cognitoInfo.companyname = _filtered.text;
    },

    // Dashboard
    resetDashbboardInfoData() {
      this.dashboardInfo.data = "";
    },
    setDashboardInfo(info) {
      this.dashboardInfo = info;
    },
    resetDashboardInfo() {
      this.dashboardInfo = {};
    },
    resetDashboardLastSync() {
      this.dashboardInfo.lastSync = null;
    },
    resetDashbboardFilter() {
      this.dashboardFilter = "";
    },
    setDashboardFilter(filter) {
      this.dashboardFilter = filter;
    },

    // Filters
    setGlobalFilter(text) {
      this.filterInfo.global = text;
    },
    resetDealFilter() {
      this.filterInfo = {};
    },
    removeGlobalFilter() {
      this.filterInfo.global = "";
    },

    // Active route
    setActiveRoute(value) {
      this.activeRoute = value;
    },

    // URL parameters
    setTenant(value) {
      if (value) this.tenant = value;
    },
    setOrigin(value) {
      if (value) this.origin = value;
    },
    setEmailParam(value) {
      if (value) this.emailParam = value;
    },
    setLanguage(value) {
      if (value) this.language = value;
    },
    setExpectedIssuer(value) {
      if (value) this.expectedIssuer = value;
    },
    setExpectedAudience(value) {
      if (value) this.expectedAudience = value;
    },
    setOrganization(value) {
      if (value) this.organization = value;
    },
    setConnection(value) {
      if (value) this.connection = value;
    },

    // Logout reset
    resetOnLogout() {
      this.tenant = "";
      this.origin = "";
      this.emailParam = "";
      this.language = "";
      this.expectedIssuer = "";
      this.expectedAudience = "";
      this.organization = "";
      this.connection = "";
      this.cognitoInfo = {};
      this.accesstoken = "";
      this.refreshtoken = "";
      this.localizationResources = {};
      this.localizationLanguage = null;
    },

    // Async action for localization
    async fetchLocalizationResources({ forceRefresh = false } = {}) {
      console.log("fetchLocalizationResources action called with forceRefresh:", forceRefresh);

      const languageCode = localStorage.getItem("selectedLanguage") || "en";

      // Return cached resources if language hasn't changed and not forcing refresh
      if (
        !forceRefresh &&
        this.localizationLanguage === languageCode &&
        Object.keys(this.localizationResources).length > 0
      ) {
        return this.localizationResources;
      }

      try {
        const DataLayerService = (await import("@/services/data-layer.service.js")).default;
        const url = forceRefresh ? `/resource/${languageCode}?forceRefresh=true` : `/resource/${languageCode}`;
        const response = await DataLayerService.get(url);
        console.log("Localization resources fetched:", response);
        if (response && Object.keys(response).length > 0) {
          const formattedResources = {};
          Object.keys(response).forEach((key) => {
            const lowerCaseKey = key.charAt(0).toLowerCase() + key.slice(1);
            formattedResources[lowerCaseKey] = response[key];
          });

          this.setLocalizationResources(formattedResources, languageCode);

          return formattedResources;
        }
      } catch (error) {
        console.error("Error fetching localization resources:", error);
        throw error;
      }
    },
  },

  persist: [
    {
      pick: [
        "cognitoInfo",
        "dashboardInfo",
        "filterInfo",
        "dashboardFilter",
        "menudataInfo",
        "routedataInfo",
        "faceBookpopup",
        "selectedLanguage",
        "headerSidebar",
        "leads",
        "integrationsValue",
        "moduleValue",
        "isFacebook",
        "isTiktok",
        "accProducts",
        "accPages",
        "accOrder",
        "orderIntegrationsValue",
        "accMarket",
        "accContact",
        "contactIntegrationsValue",
        "accInventory",
        "inventoryIntegrationsValue",
        "accReceipt",
        "receiptIntegrationsValue",
        "ratingsAndReviewsSelectedSiteId",
        "isMultiPromotionsEnable",
        "isEnableMediaComponent",
        "isEnableDeprecatedSite",
        "isRatingsAndReviewsEnabled",
        "callLogSite",
        "errorLogSite",
        "errorIntegrationsValue",
        "errorModuleValue",
        "notifiedErrorCount",
        "email",
        "tenant",
        "origin",
        "emailParam",
        "language",
        "expectedIssuer",
        "expectedAudience",
        "organization",
        "connection",
        "refreshtoken",
        "accesstoken",
      ],
    },
    {
      pick: [
        "localizationResources",
        "localizationLanguage",
      ],
      storage: sessionStorage,
    },
  ],
});
